import {
  useInfiniteQuery,
  UseInfiniteQueryResult,
  useMutation,
  UseMutationResult,
  useQuery,
  UseQueryResult,
} from "@tanstack/react-query";
import { axiosChat, throwResponse } from "config/axios";
import { IResponse } from "config/axios/interface";
import {
  Firestore,
  DocumentData,
  collection,
  getDocs,
} from "firebase/firestore";
import { postMediaObject } from "service/media-object";
import { IHistoryMessageParams, IMessages } from "./interface";

export const useGetCollection = ({
  db,
  collectionName,
}: {
  db: Firestore;
  collectionName: string;
}): UseQueryResult<DocumentData[]> => {
  return useQuery([db, collectionName], async () => {
    const col = collection(db, collectionName);
    const colSnapshot = await getDocs(col);
    const list = colSnapshot.docs.map((doc) => {
      return doc.data();
    });
    return list;
  });
};

export const usePostMessage = (): UseMutationResult<unknown, Error> => {
  return useMutation(async ({ ...data }: any) => {
    if (
      data.type === "FILE" ||
      data.type === "IMAGE" ||
      data.type === "VIDEO"
    ) {
      const mediaObject = await postMediaObject(data.message , false);
      data = { ...data, message: mediaObject };
    }
    const res = await axiosChat.post(`/message/create-message`, data);
    if (res.status === 200) {
      return res.data.data;
    }
    throwResponse(res);
  });
};

export const usePatchReadMessage = (): UseMutationResult<unknown, Error> => {
  return useMutation(async ({ ...data }: any) => {
    const res = await axiosChat.patch(`/message/read-message`, data);
    if (res.status === 200) {
      return;
    }
    throwResponse(res);
  });
};

export const useScrollGetHistoryMessage = (
  params?: IHistoryMessageParams
): UseInfiniteQueryResult<IResponse<IMessages[]>, Error> => {
  return useInfiniteQuery(
    ["chat-messages", "scroll", params],
    async ({ pageParam }) => {
      const res = await axiosChat.get("/message/filter-history-message", {
        params: { ...params, ...pageParam },
      });
      if (res.status === 200) {
        return res.data;
      }
      throwResponse(res);
    },
    { keepPreviousData: true, enabled: params?.enabled }
  );
};
